/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DoctorDocType = {
    NationalIdFront: 'National ID Front',
    NationalIdBack: 'National ID Back',
    ResidencyCardFront: 'Residency Card Front',
    ResidencyCardBack: 'Residency Card Back',
    ImaIdFront: 'IMA ID Front',
    ImaIdBack: 'IMA ID Back',
    MedicalLicenseFront: 'Medical License Front',
    MedicalLicenseBack: 'Medical License Back',
    FacePhoto: 'Face Photo',
    PassportFront: 'Passport Front',
    PassportBack: 'Passport Back',
    MedicalCertificateFront: 'Medical Certificate Front',
    MedicalCertificateBack: 'Medical Certificate Back',
    Kyc: 'Kyc'
} as const;
export type DoctorDocType = typeof DoctorDocType[keyof typeof DoctorDocType];


export function instanceOfDoctorDocType(value: any): boolean {
    return Object.values(DoctorDocType).includes(value);
}

export function DoctorDocTypeFromJSON(json: any): DoctorDocType {
    return DoctorDocTypeFromJSONTyped(json, false);
}

export function DoctorDocTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoctorDocType {
    return json as DoctorDocType;
}

export function DoctorDocTypeToJSON(value?: DoctorDocType | null): any {
    return value as any;
}

